import { useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { useState } from "react";
import FortalezasAreasListLayerPlantel from "../../../components/FortalezasAreasListLayerPlantel";
import FortalezasAccionesListLayerPlantel from "../../../components/FortalezasAccionesListLayerPlantel";

const FortalezasPlantelPage = () => {
  const { plantelId } = useParams();
  const [activeTab, setActiveTab] = useState("areas");

  const tabs = [
    { id: "areas", label: "Áreas de Desarrollo", icon: "mdi:shape-outline" },
    { id: "acciones", label: "Acciones de Desarrollo", icon: "mdi:lightbulb-outline" },
  ];

  return (
    <div className="container-fluid">
      {/* HEADER */}
      <div className="mb-3">
        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <h6 className="mb-0 fw-semibold">Fortalezas del plantel</h6>
          </div>

          <Link
            className="btn btn-outline-primary d-flex align-items-center gap-2 btn-sm"
            to="/planteles"
          >
            <Icon icon="mdi:arrow-left" width="18" />
            <span>Atras</span>
          </Link>
        </div>
      </div>

      {/* CARD */}
      <div className="card radius-8">
        <div className="card-header py-16 px-24">
          <ul className="nav nav-tabs border-neutral-200 gap-12" role="tablist">
            {tabs.map((tab) => (
              <li className="nav-item" role="presentation" key={tab.id}>
                <button
                  className={`nav-link d-flex align-items-center gap-2 px-20 py-12 radius-8 text-md fw-medium ${activeTab === tab.id ? "active" : "text-neutral-600"}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <Icon icon={tab.icon} width="18" /> {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="card-body p-24">
          {activeTab === "areas" && <FortalezasAreasListLayerPlantel key={`areas-${plantelId}`} />}
          {activeTab === "acciones" && <FortalezasAccionesListLayerPlantel key={`acciones-${plantelId}`} />}
        </div>
      </div>
    </div>
  );
};

export default FortalezasPlantelPage;
